const site = 'La Piquera'
const email = 'miel.lapiquera@gmail.com'
const fb = 'https://www.facebook.com/miel.lapiquera/'
const address = 'calle 62 y 19. s./n, Balcarce, Bs. As., Argentina'

const heroTitle = 'Miel de abeja 100% natural'
const heroCopy = 'Nuestra miel no solo es producida por un equipo de expertos en apicultura, sino que también es 100% natural.'

const packageTitle = 'Miel multifloral'
const packageCopy = 'De color ámbar claro y sabor dulce y suave. Cristaliza rápidamente en una masa blanca sólida de grano fino gracias a su ausencia de aditivos.'
const packageNote = 'Notas de eucalipto y trébol.'
const packages = [ '1kg', '500gr', '250gr' ]
const packagesOverText = 'Envasamos nuestra propia miel, tarro a tarro, de forma totalmente artesanal, sin añadir ningún tipo de colorante, ni azucares añadidos.'

const locationTitle = 'Desde nuestras colmenas a tu casa'
const locationCopy = 'En el corazón de las sierras de Balcarce y con una flora privilegiada nuestro entorno nos proporciona las mejores condiciones para recolectar la miel.'


export { 
    site,
    email,
    fb,
    address,
    heroTitle, 
    heroCopy,
    packageTitle,
    packageCopy,
    packageNote,
    packages,
    packagesOverText,
    locationTitle,
    locationCopy
}